(() => {
  const closeMenus = () => document.querySelectorAll('.mobile-nav[open]').forEach(menu => { menu.open = false; });
  document.addEventListener('click', event => {
    if (event.target.closest('.mobile-nav a') || !event.target.closest('.mobile-nav')) closeMenus();
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.mobile-nav[open]');
    if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
  });
  const productField = document.querySelector('[data-enquiry-product]');
  const requestedProduct = new URLSearchParams(window.location.search).get('product');
  if (productField && requestedProduct && !productField.value) productField.value = requestedProduct;
})();
